'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import ZendwebServices from '@/components/technologies/zend-services';
import YiiModelsOfWorking from '@/components/technologies/yii-models-of-working';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Ensure Featured-Rich and Futuristic Web Solutions for Your Business with Zend Web Development!"
                alt="Zend Web Development"
                title="Zend Web Development"
                width={1090}
                height={604}
                path={'zendweb-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                Zend Web Development
            </TechHero>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Zend Development" />
            <ContetVideoSection title="How Zend PHP Development Help You to Grow Your Business?">
                <>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        Being simple, object-oriented and open-source in nature, Zend has conceptualized the idea of offering an
                        interactive and scalable solution that meet individual business goals and objectives. Preferred as first
                        and foremost option for developers and clients, it is regarded as one of the best PHP frameworks to build
                        high-quality and result-oriented applications. It’s highly configurable nature of multiple operating
                        systems makes it one of the most reliable choices for web and mobile solutions. So, if your business is
                        looking out for futuristic yet cutting-edge and interactive web solution, Moweb- A leading Zend
                        development company is the best address to partner with.
                    </p>
                </>
            </ContetVideoSection>
            <ZendwebServices title="Do You Have Zend Project Idea in Your Mind? We Have Pool of Zend Developers"></ZendwebServices>

            <HireProcess
                bg="bg-zend"
                pageTitle="Hire Custom Zend Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using Zend."
            />
            <WhyChooseUs pageTitle="Why Clients Choose Moweb for Zend Consulting?" />

            <YiiModelsOfWorking
                title="Engagement models to hire the best Zend Developers"
                desc="Select from different engagement models to hire Zend Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />

            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
